var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DefaultAutoComplete } from '../DefaultAutoComplete';
import { HandleError } from '../../modules/utils/HandleError';
import { ProjetoFundiariosApi } from '../../apis/projetos-fundiarios-api';
import { isEmpty, nonNull } from '../../util/CommonUtils';
export var otherProjOption = { id: null, nome: 'Outro' };
export var CampoLoteamento = function (_a) {
    var _b, _c;
    var _d = _a.noOptionsText, noOptionsText = _d === void 0 ? 'Nenhum projeto fundiário encontrado' : _d, _e = _a.placeholder, placeholder = _e === void 0 ? 'Informe a COHAB/Loteamento' : _e, _f = _a.otherOption, otherOption = _f === void 0 ? otherProjOption : _f, _g = _a.modeType, modeType = _g === void 0 ? 'municipioOrigem' : _g, _h = _a.name, name = _h === void 0 ? 'projetoFundiario' : _h, _j = _a.fullWhenAlone, fullWhenAlone = _j === void 0 ? true : _j, _k = _a.addOther, addOther = _k === void 0 ? false : _k, _l = _a.required, required = _l === void 0 ? true : _l, _m = _a.refChange, refChange = _m === void 0 ? null : _m, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.mode, mode = _p === void 0 ? 'automatic' : _p, _q = _a.valueList, valueList = _q === void 0 ? [] : _q, onShowChange = _a.onShowChange, fieldError = _a.fieldError, _r = _a.tipo, tipo = _r === void 0 ? [] : _r, onChange = _a.onChange, label = _a.label, value = _a.value;
    //region Constants
    var _s = useState([]), values = _s[0], setValues = _s[1];
    var _t = useState(), error = _t[0], setError = _t[1];
    //endregion
    //region Hooks
    var isAutomaticMode = useMemo(function () {
        return mode === 'automatic';
    }, [mode]);
    var refType = useMemo(function () {
        return (tipo !== null && tipo !== void 0 ? tipo : []).join(',');
    }, [tipo]);
    var selectProjetoProm = useCallback(function () {
        if (isAutomaticMode) {
            var params = {};
            if (refType && (refType === null || refType === void 0 ? void 0 : refType.length) > 0) {
                params['tipos'] = refType;
            }
            var municipioId = typeof refChange === 'object' ? refChange === null || refChange === void 0 ? void 0 : refChange.id : refChange;
            if (municipioId) {
                params['municipioId'] = municipioId;
            }
            if (modeType === 'municipioIBGE') {
                return ProjetoFundiariosApi.selectAllByMunicipioAssentamento(params);
            }
            return ProjetoFundiariosApi.selectAllByMunicipioOrigemAssentamento(params);
        }
        return Promise.resolve([]);
    }, [refType, refChange, isAutomaticMode, modeType]);
    var show = useMemo(function () {
        var _a;
        return addOther && (((_a = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.nome) === (otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome) || !!(value === null || value === void 0 ? void 0 : value.bairro));
    }, [addOther, (_b = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _b === void 0 ? void 0 : _b.nome, value === null || value === void 0 ? void 0 : value.bairro, otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome]);
    var isOutroProj = useMemo(function () {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.nome) === (otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome);
    }, [(_c = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _c === void 0 ? void 0 : _c.nome, otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome]);
    var size = useMemo(function () {
        var _size = (fullWhenAlone ? 12 : 6);
        return isOutroProj ? 6 : _size;
    }, [isOutroProj, fullWhenAlone]);
    useEffect(function () {
        if (nonNull(value === null || value === void 0 ? void 0 : value.bairro) && !isEmpty(value === null || value === void 0 ? void 0 : value.bairro)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { projetoFundiario: otherOption }));
        }
    }, []);
    useEffect(function () {
        if (isAutomaticMode) {
            selectProjetoProm().then(function (response) {
                if (addOther) {
                    setValues(__spreadArray([otherOption], response, true));
                }
                else {
                    setValues(__spreadArray([], response, true));
                }
                if (value === null || value === void 0 ? void 0 : value.projetoFundiario) {
                    var allProjects = addOther ? __spreadArray([otherOption], response, true) : response;
                    var projectExists = allProjects.some(function (proj) {
                        var _a, _b;
                        return proj.id === ((_a = value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id) ||
                            (proj.nome === otherOption.nome && ((_b = value.projetoFundiario) === null || _b === void 0 ? void 0 : _b.nome) === otherOption.nome);
                    });
                    if (!projectExists) {
                        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { projetoFundiario: undefined, quadra: undefined, lote: undefined, bairro: undefined, outroProjeto: undefined }));
                    }
                }
            }).catch(function (error) {
                setError(error);
            });
        }
        else {
            setValues(valueList);
        }
    }, [refChange, refType, isAutomaticMode, addOther, selectProjetoProm]);
    useEffect(function () {
    }, [values, value, tipo]);
    useEffect(function () {
        onShowChange === null || onShowChange === void 0 ? void 0 : onShowChange(show);
    }, [show]);
    useEffect(function () {
        if (addOther && !!(value === null || value === void 0 ? void 0 : value.bairro)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), { projetoFundiario: otherOption }));
        }
    }, [show, addOther]);
    var handleChange = function (dadosImovel) {
        var _a;
        if (((_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.projetoFundiario) === null || _a === void 0 ? void 0 : _a.nome) !== (otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, dadosImovel), { bairro: undefined, outroProjeto: undefined }));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, dadosImovel));
        }
    };
    // endregion
    return (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, xs: 12, xl: size, lg: size, md: size }, { children: _jsx(DefaultAutoComplete, { onChange: function (_projetoFundiario) { return handleChange(__assign(__assign({}, value), { projetoFundiario: _projetoFundiario || undefined })); }, value: value === null || value === void 0 ? void 0 : value.projetoFundiario, noOptionsText: noOptionsText, placeholder: placeholder, fieldError: fieldError, disabled: disabled, required: required, fieldsList: values, refChange: values, label: label, name: name }) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
